(() => {
  if (customElements.get('chilzz-amber')) return;
  const classify = (variant) => {
    const title = variant.title.toLowerCase();
    if (variant.options?.length === 2 && /schaaltje/.test(variant.options[0])) {
      return [title.includes('rechthoekig') ? 3 : title.includes('ovaal') ? 2 : title.startsWith('geen schaaltje') ? 0 : 1, variant.options[1].startsWith('Geen') ? 0 : variant.options[1].startsWith('Zwart') ? 1 : 2];
    }
    return [title.includes('schaaltje') || title.includes('complete') ? 1 : 0, title.includes('zwart') ? 1 : title.includes('zilver') ? 2 : 0];
  };
  class ChilzzAmber extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-amber-config]').textContent);
      this.money = new Intl.NumberFormat('nl-NL', {style:'currency',currency:this.dataset.currency || 'EUR'});
      this.form = this.querySelector('form');
      this.total = this.querySelector('[data-total]');
      this.bowl = this.querySelector('[data-bowl]');
      this.grater = this.querySelector('[data-grater]');
      this.idSelect = this.querySelector('[data-variant]');
      this.matrix = new Map(this.config.variants.map(v => [classify(v).join('-'),v]));
      const selected = this.config.variants.find(v => String(v.id) === this.idSelect.value) || this.config.variants[0];
      const [b,r] = classify(selected);
      this.bowl.value = String(b);
      this.grater.value = String(r);
      this.querySelector('[data-fallback]').hidden = true;
      this.querySelector('[data-options]').hidden = false;
      this.bowl.disabled = this.grater.disabled = false;
      this.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', event => {
        const variant = this.matrix.get(`${this.bowl.value}-${this.grater.value}`);
        if (!variant?.available || this.idSelect.value !== String(variant.id)) event.preventDefault();
      });
      this.update();
    }
    update() {
      const b = Number(this.bowl.value), r = Number(this.grater.value);
      const v = this.matrix.get(`${b}-${r}`);
      const noGrater = this.matrix.get(`${b}-0`);
      Array.from(this.bowl.options).forEach((o,i) => {
        const priceVariant = this.matrix.get(`${i}-0`);
        const possible = this.matrix.get(`${i}-${r}`);
        o.disabled = !possible?.available;
        o.textContent = this.config.bowlNames[i] + (priceVariant ? ` (+ ${this.money.format((priceVariant.price-this.config.base)/100)})` : '');
      });
      Array.from(this.grater.options).forEach((o,i) => {
        const possible = this.matrix.get(`${b}-${i}`);
        o.disabled = !possible?.available;
        o.textContent = this.config.graterNames[i] + (possible && noGrater ? ` (+ ${this.money.format((possible.price-noGrater.price)/100)})` : '');
      });
      this.form.querySelector('button[type=submit]').disabled = !v?.available;
      this.querySelector('[data-status]').textContent = v?.available ? '' : this.config.unavailableLabel;
      if (!v) return;
      this.idSelect.value = String(v.id);
      this.total.textContent = this.money.format(v.price/100);
      const retailBase = this.dataset.mix === 'true' ? (this.dataset.block === 'true' ? 1200 : 1785) : this.config.base;
      const fullPrice = retailBase + [0,550,495,750][b] + (r ? 395 : 0);
      const benefit = this.querySelector('[data-benefit]');
      benefit.hidden = fullPrice <= v.price;
      benefit.textContent = this.config.benefitLabel + ' ' + this.money.format((fullPrice-v.price)/100);
    }
  }
  customElements.define('chilzz-amber', ChilzzAmber);
})();
